module.exports = __webpack_public_path__ + "media/mypage/images/icons/s_icon_tokucho-f429a3d0a1f6b4cef75ace9c30e4a2eb.png";